/**
 * @module Reports Issue actions
 * @desc this Reports actions help us to call the Reports page api's 
 * @return {Object} List of actions
 */

import {POST_ISSUES, POST_ISSUES_SUCCESSFULL,POST_ISSUES_FAILED, GET_REPORT_LIST,GET_REPORT_LIST_SUCCESS,GET_REPORT_LIST_FAIL, GET_REPORT_LIST_SEARCH,
  GET_REPORT_LIST_FILE_DATA,GET_REPORT_LIST_FILE_DATA_SUCCESS,GET_REPORT_LIST_FILE_DATA_FAIL ,UPDATE_REPORT_ISSUE_STATUS,UPDATE_REPORT_ISSUE_STATUS_SUCCESS,UPDATE_REPORT_ISSUE_STATUS_FAIL,
  GET_CHAT_MODAL_DATA,GET_CHAT_MODAL_DATA_SUCCESS, GET_CHAT_MODAL_DATA_FAIL,POST_MODAL_DATA,POST_MODAL_DATA_SUCCESS,POST_MODAL_DATA_FAIL,
  GET_CHAT_MODAL_DATA_CLIENT,POST_MODAL_DATA_CLIENT, GET_DELETE_TICKET, GET_DELETE_TICKET_SUCCESS, GET_DELETE_TICKET_FAIL, LAST_JSON_TICKET_REQUEST
} from "./actionTypes";

  /** 
   * @property {function} postIssues function is used to call the postIssues api (it is used to post the new issues)
   * @param {*} object contains values
   */
export const postIssues = (data) => {
  return {
    type: POST_ISSUES,
    payload: data,
  };
};

 /** 
   * @property {function} postIssuesSuccessfull function is used to handel the postIssue api response
   * @param {*} object contains values
   */
export const postIssuesSuccessfull = (data) => {
  return {
    type: POST_ISSUES_SUCCESSFULL,
    payload: data,
  };
};

 /** 
   * @property {function} postIssuesFailure function is used to handel the postIssue api error messages
   * @param {*} object contains values
   */
export const postIssuesFailure = (error) => {
  return {
    type: POST_ISSUES_FAILED,
    payload: error,
  };
};

  /** 
   * @property {function}getReportList function is used to call the reports list api
   * @param {*} object contains values
   */
export const getReportList = (data) => {
  return {
    type: GET_REPORT_LIST,
    payload: {data},
  };
};

 /** 
   * @property {function} getReportListSuccess function is used to handel the reports list api response
   * @param {*} object contains values
   */
export const getReportListSuccess = (data) => {
  return {
    type: GET_REPORT_LIST_SUCCESS,
    payload: data,
  };
};

 /** 
   * @property {function} getReportListFail function is used to handel the reports list api error message
   * @param {*} object contains values
   */
export const getReportListFail = (error) => {
  return {
    type: GET_REPORT_LIST_FAIL,
    payload: error,
  };
};

  /** 
   * @property {function} getSearchReportList function is used to call the reports search api
   * @param {*} object contains values
   */
export const getSearchReportList = (data) => {
  return {
    type: GET_REPORT_LIST_SEARCH,
    payload: {data},
  };
};

// file data

  /** 
   * @property {function} getReportIssuFIleData function is used to call the reports file data api
   * @param {*} number contains id
   */
export const getReportIssuFIleData = (data) => {
  return {
    type: GET_REPORT_LIST_FILE_DATA,
    payload: {data},
  };
};

  /** 
   * @property {function} getReportIssuFIleData function is used to handel the reports file data api response
   * @param {*} object contains value
   */
export const getReportIssuFIleDataSuccess = (data) => {
  return {
    type: GET_REPORT_LIST_FILE_DATA_SUCCESS,
    payload: {data},
  };
};

  /** 
   * @property {function} getReportIssuFIleDataFail function is used to handel the reports file data api error message
   * @param {*} object contains value
   */
export const getReportIssuFIleDataFail = (data) => {
  return {
    type: GET_REPORT_LIST_FILE_DATA_FAIL ,
    payload: {data},
  };
};

//update status

  /** 
   * @property {function} updateReportIssuData function is used to call the issue status update api 
   * @param {*} number contains id
   */
export const updateReportIssuData = (data) => {
  return {
    type: UPDATE_REPORT_ISSUE_STATUS,
    payload: {data},
  };
};

  /** 
   * @property {function} updateReportIssuDataSuccess function is used to handel the reports file data api response
   * @param {*} object contains value
   */
export const updateReportIssuDataSuccess = (data) => {
  return {
    type: UPDATE_REPORT_ISSUE_STATUS_SUCCESS,
    payload: {data},
  };
};

  /** 
   * @property {function} updateReportIssuDataFail function is used to handel the reports file data api error message
   * @param {*} object contains value
   */
export const updateReportIssuDataFail = (data) => {
  return {
    type: UPDATE_REPORT_ISSUE_STATUS_FAIL ,
    payload: {data},
  };
};

// chat modal
export const getChatModal = (data) => {
  return {
    type: GET_CHAT_MODAL_DATA,
    payload: {data},
  };
};

//chat modalFor client
export const getChatModalClient = (data) => {
  return {
    type: GET_CHAT_MODAL_DATA_CLIENT,
    payload: {data},
  };
};

export const getChatModalSuccess = (data) => {
  return {
    type: GET_CHAT_MODAL_DATA_SUCCESS,
    payload: {data},
  };
};

export const getChatModalFail = (data) => {
  return {
    type: GET_CHAT_MODAL_DATA_FAIL,
    payload: {data},
  };
};

export const postChatData = (data) => {
  return {
    type: POST_MODAL_DATA,
    payload: {data},
  };
};

//chat modal client
export const postChatDataClient = (data) => {
  return {
    type: POST_MODAL_DATA_CLIENT,
    payload: {data},
  };
};

export const postChatDataSuccess = (data) => {
  return {
    type: POST_MODAL_DATA_SUCCESS,
    payload: {data},
  };
};

export const postChatDataFail = (data) => {
  return {
    type: POST_MODAL_DATA_FAIL,
    payload: {data},
  };
};

//delete ticket
export const deleteTicket = (data) => {
  return {
    type: GET_DELETE_TICKET,
    payload: data,
  };
};

export const deleteTicketSuccess = (data) => {
  return {
    type: GET_DELETE_TICKET_SUCCESS,
    payload: data,
  };
};

export const deleteTicketError = (data) => {
  return {
    type: GET_DELETE_TICKET_FAIL,
    payload: data,
  };
};

export const lastJsonTicketRequest = (data) => {
  return {
    type:LAST_JSON_TICKET_REQUEST,
    payload: data,
  };
};

